module.exports = __webpack_public_path__ + "img/cv-template-9.69471fb6.png";